import { createRouter, createWebHashHistory } from 'vue-router';
import { auth } from '@/store';
import routes from './routes';

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => !record.meta.anonymous)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!auth.token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
